import { useLocation } from "react-router-dom"
import { routes } from "routing/Routing"

export const useHideNavBaseOnLocation = (): boolean => {
    const location = useLocation()

    return routes?.find(route => location.pathname.includes(route.path.split(':')[0]))?.hasNoNavigation
}